import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ImageWithDescription from "../../components/ImageAndText/ImageWithDescription";
import image from "../../imgs/image1.png";
import Step4Form from "./Forms/Step4Form";
import CustomAccordion from "../../components/Accordion/Accordion";

const Solution4 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accordionBusinessItems = [
    {
      title: "Comment la blockchain améliore-t-elle l'expérience client ?",
      content:
        "La blockchain permet aux consommateurs d’accéder directement à des informations détaillées sur l’origine, la fabrication, et le parcours des produits. Cette transparence accrue renforce la crédibilité de la marque et la confiance des clients permettant de les fidéliser.",
    },
    {
      title:
        "Comment la blockchain contribue-t-elle à une chaîne d'approvisionnement plus durable ?",
      content:
        "La blockchain permet une traçabilité complète et vérifiable des produits, facilitant le suivi de l'origine des matières premières et leur conformité aux critères de durabilité. En fournissant des preuves transparentes de l’origine et des pratiques éthiques, elle aide les entreprises à répondre aux attentes des consommateurs et des régulateurs en matière de durabilité, tout en renforçant leur image de marque.",
    },
    {
      title:
        "Comment la blockchain peut-elle améliorer la communication entre les marques et les consommateurs ?",
      content:
        "La blockchain permet aux marques de partager des informations vérifiées et transparentes sur les produits, renforçant ainsi leur crédibilité. En plus de fournir des détails fiables en temps réel, elle facilite également une communication plus directe avec les consommateurs. Les marques peuvent interagir plus efficacement avec leurs clients, répondre rapidement aux questions et recevoir des retours, améliorant ainsi l'expérience utilisateur et la satisfaction client.",
    },
    {
      title:
        "Quels avantages la blockchain offre-t-elle pour la gestion des rappels de produits ?",
      content:
        "La blockchain permet de localiser rapidement les produits concernés par un rappel en suivant leur parcours complet dans la chaîne d'approvisionnement. Cela accélère le processus de rappel, minimise les risques pour les consommateurs et renforce la sécurité des produits.",
    },
  ];

  const accordionTechniquesItems = [
    {
      title:
        "Comment un consommateur final peut-il accéder aux informations détaillées d'un produit enregistré sur la blockchain ?",
      content:
"Les consommateurs finaux peuvent accéder aux informations détaillées d'un produit de plusieurs façons : en scannant un QR code imprimé sur l'emballage, en utilisant une puce NFC intégrée dans le produit, ou en consultant un portail dédié mis en place par la société. Ces mécanismes permettent de récupérer les données enregistrées sur la blockchain en temps réel, offrant ainsi des garanties sur l'origine et le parcours du produit."
    },
    {
      title:"Qu’est-ce qu’un algorithme de consensus en blockchain ?",
      content: "Un algorithme de consensus est un mécanisme utilisé dans les réseaux blockchain pour parvenir à un accord sur l’état actuel de la chaîne de blocs parmi les participants du réseau. Il garantit que toutes les copies du registre distribué sont identiques et que seules les transactions valides sont ajoutées à la blockchain.",
    },
    {
      title: "Quelles sont les principales fonctions d'un algorithme de consensus ?",
      content: "Les algorithmes de consensus valident les transactions en s'assurant qu'elles respectent les règles du réseau, garantissant ainsi leur intégrité. Ils renforcent la sécurité et l'immuabilité des données, protégeant contre les attaques et empêchant les modifications non autorisées. En permettant à un réseau décentralisé de parvenir à un accord sans autorité centrale, ils assurent la synchronisation et la cohérence des données à travers tous les participants"
    },
    {
      title: "Quels sont les types d'algorithmes de consensus utilisés dans les réseaux blockchain ?",
      content: "Les algorithmes de consensus courants incluent le Proof of Work (PoW), le Proof of Stake (PoS), le Delegated Proof of Stake (DPoS), le Practical Byzantine Fault Tolerance (PBFT) et bien d’autres. Le PoW assure une haute sécurité mais coûte en énergie, le PoS réduit les coûts énergétiques, le DPoS accélère les transactions, et le PBFT est adapté aux réseaux privés avec une bonne tolérance aux défaillances."
    },
  ];

  return (
    <div className="supply-chain-wrapper">
      <Header text="Chaîne d’approvisionnement" />
      <ImageWithDescription
        imageSrc={image}
        imageAlt="Image Information"
        description={[
          "La chaîne d'approvisionnement a été simplifiée pour illustrer le cas d'usage de manière claire. Dans ce scénario, la volaille est arrivée en grande surface, où le client final peut désormais consulter un résumé détaillé de l'ensemble du parcours du produit grâce à la blockchain.",
          "En scannant le QR code, le client final peut accéder à un résumé détaillé et immuable de toutes les données, de l'élevage à la distribution. Cela inclut les informations sur l'élevage, l'éclosion, l'abattage, la transformation et la distribution, assurant une traçabilité totale et complète.",
          "Cette fonctionnalité renforce la confiance des consommateurs et des partenaires commerciaux.",
        ]}
      />
      <div className="container">
        <div className="steps-info">
          <h3 className="step-title">Étape 4: Information sur le produit</h3>
        </div>

        <Step4Form />

        <div className="accordians-wrapper">
          <div className="accordians-bussiness-main">
            <h3>Questions Business</h3>
            <CustomAccordion items={accordionBusinessItems} />
          </div>

          <div className="accordians-techniques-main">
            <h3>Questions Techniques</h3>
            <CustomAccordion items={accordionTechniquesItems} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Solution4;
